<div class="rename-modal">
  <sync-dialog 
    [config]="{
      title: 'Rename',
      isClosable: true,
      closeIcon: 'close',
      subTitle: Title,
      actionButton: !isDirRenameWithPreserveAllowed ? 'Rename' : 'Close',
      isActionButtonDisabled: isActionDisable,
      cancelButton: !isDirRenameWithPreserveAllowed && 'Cancel',
      onActionClick: !isDirRenameWithPreserveAllowed ? onRenameClick : closeDialogWithProgress,
      onCancelClick: closeDialog,
      isButtonLoading: !isDirRenameWithPreserveAllowed && isRenameProcessing
    }" 
    [open]="isOpen" 
    [onClose]="closeDialog">
    
    <div class="rename-modal-body">
      <app-error *ngIf="errcode" [errcode]="errcode"></app-error>
      
      <sync-alert 
        *ngIf="(Item?.is_publink || Item?.is_shared) && !isLinkPreserveAllowed" 
        [type]="'warning'" 
        [leadIcon]="'warning'"
        [showLeadIcon]="true" 
        [description]="'Renaming this file will delete its shared link.'" 
        [showCloseButton]="false" 
        [showActions]="false" 
        [showPrimaryAction]="false" 
        [showSecondaryAction]="false">
      </sync-alert>
      
      <sync-text-field 
        #fileNameInput
        *ngIf="!isDirRenameWithPreserveAllowed" 
        [label]="Item?.type === 'dir' ? 'Folder name' : 'File name'" 
        [inputChange]="getItemName" 
        [value]="itemName" 
        [errorMessage]="nameInvalidError">
      </sync-text-field>
      
      <div *ngIf="isDirRenameWithPreserveAllowed">
        <div class="process-body">
          <sync-spinner></sync-spinner>
          <span class="subtitle">Updating file paths... - {{ batchView.percent }}%</span>
        </div>
      </div>
    </div>
  </sync-dialog>
</div>
